import { Pin, Plus, X } from "lucide-react";

export const MAX_OPTIONS = 6;
const DURATIONS = [[1, "1 Tag"], [3, "3 Tage"], [7, "1 Woche"], [null, "Unbegrenzt"]];

export function PollEditor({ poll, setPoll, onRemove, canPin }) {
  const setOpt = (i, val) => setPoll((p) => ({ ...p, options: p.options.map((o, j) => (j === i ? val : o)) }));
  const delOpt = (i) => setPoll((p) => ({ ...p, options: p.options.filter((_, j) => j !== i) }));
  return (
    <div className="rounded-2xl border border-rose-100 bg-rose-50/40 p-3 space-y-2" data-testid="poll-editor">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-wider text-rose-600">Umfrage · deine Frage steht oben im Text</p>
        <button onClick={onRemove} data-testid="poll-editor-remove" title="Umfrage entfernen" className="p-1 rounded-full text-slate-400 hover:text-red-600"><X className="w-4 h-4" /></button>
      </div>
      {poll.options.map((o, i) => (
        <div key={i} className="flex items-center gap-2">
          <input value={o} onChange={(e) => setOpt(i, e.target.value)} maxLength={80} placeholder={`Antwort ${i + 1}`} data-testid={`poll-editor-option-${i}`}
            className="flex-1 min-w-0 h-10 px-4 rounded-full bg-white border border-rose-100 text-sm focus:outline-none focus:border-rose-300" />
          {poll.options.length > 2 && <button onClick={() => delOpt(i)} data-testid={`poll-editor-del-${i}`} className="p-1.5 rounded-full text-slate-400 hover:text-red-600"><X className="w-4 h-4" /></button>}
        </div>
      ))}
      {poll.options.length < MAX_OPTIONS && (
        <button onClick={() => setPoll((p) => ({ ...p, options: [...p.options, ""] }))} data-testid="poll-editor-add-option" className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-sm font-semibold text-rose-600 hover:bg-rose-50"><Plus className="w-4 h-4" /> Antwort hinzufügen</button>
      )}
      <div className="flex flex-wrap gap-1.5 pt-1">
        {DURATIONS.map(([d, l]) => (
          <button key={l} onClick={() => setPoll((p) => ({ ...p, days: d }))} data-testid={`poll-editor-days-${d ?? "none"}`}
            className={`px-3 h-8 rounded-full text-xs font-bold transition-colors ${poll.days === d ? "pink-gradient text-white" : "bg-white text-slate-500 border border-rose-100"}`}>{l}</button>
        ))}
      </div>
      {canPin && (
        <label className="flex items-center gap-2 pt-1 text-sm font-semibold text-slate-600 cursor-pointer select-none" data-testid="poll-editor-pin">
          <input type="checkbox" checked={!!poll.pin} onChange={(e) => setPoll((p) => ({ ...p, pin: e.target.checked }))} data-testid="poll-editor-pin-checkbox" className="w-4 h-4 accent-rose-500" />
          <Pin className="w-4 h-4 text-rose-500" /> Oben im Feed anpinnen
        </label>
      )}
    </div>
  );
}
